import { render, staticRenderFns } from "./Homework.vue?vue&type=template&id=1b5e2e0a&scoped=true"
import script from "./Homework.vue?vue&type=script&lang=js"
export * from "./Homework.vue?vue&type=script&lang=js"
import style0 from "./Homework.vue?vue&type=style&index=0&id=1b5e2e0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5e2e0a",
  null
  
)

export default component.exports